"use strict";

angular.module("Finance").config([
    "$oidcProvider",
    function (oidcProvider) {
        oidcProvider.configure({
            app_prefix: "finance",
            authority: __FINANCE__.auth.authority,
            client_id: __FINANCE__.auth.clientId,
            response_type: "id_token token",
            scope: "openid profile finance",
            sessions: 4,
            jwks_uri_path: ""
        });
    }
]);
